module.exports = __webpack_public_path__ + "static/media/eve-link.4cd08dcb.svg";